import { type RovoContentBridgeAPIShape } from '@atlassian/rovo-content-bridge-api/dist/types/rovo-bridge-api-interface';

import {
  type CommandConstructor,
  type CommandProperties,
} from '@canvas/rovo-content-bridge-api';

interface PendingEvent {
  command: CommandConstructor;
  params: CommandProperties;
}

class BridgeEventEmitter {
  private pendingEvents: PendingEvent[] = [];
  private bridge: RovoContentBridgeAPIShape | null = null;

  initBridge = (bridge: RovoContentBridgeAPIShape) => {
    this.bridge = bridge;
    this.pendingEvents.forEach((event) => {
      bridge.send(event.command, event.params);
    });
    this.pendingEvents = [];
  };

  sendEvent = (command: CommandConstructor, params: CommandProperties) => {
    if (this.bridge) {
      this.bridge.send(command, params);
    } else {
      this.pendingEvents.push({ command, params });
    }
  };
}

export const bridgeEventEmitter = new BridgeEventEmitter();
